import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customList'
})
export class CustomListPipe implements PipeTransform {

  transform(value: any, bindName: any, label: any = null): any {
    const type = typeof (bindName);
    if (value == null || value.length == 0 || bindName == null) {
      return null;
    } else {
      let list;
      if (type == 'string') {
        list = [];
        list = value.map((val) => {
          return val[bindName];
        });
      } else if (type == 'object') {
        list = [];
        list = value.filter((value) => bindName.indexOf(value['id']) != -1).map((val) => {
          return val[label];
        });
      } else if (type == 'number') {
        list = value.filter((value) => value['id'] == bindName)[0][label];
      }
      return list;
    }
  }

}
